import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getInitials'
})
export class GetInitialsPipe implements PipeTransform {
    transform(contact: { contactName?: string; name?: string; contactEmails?: string[]; email?: string }) {
        /** name and email should exist on the meeting host (user). contactName and/or contactEmail can be found on other contacts (invitees) */
        const name =
            contact.contactName || contact.name || (contact.contactEmails && contact.contactEmails[0]) || contact.email;
        return name.charAt(0).toUpperCase();
    }
}
